export default "__VITE_ASSET__DcDBg0Oh__"